import Vue from 'vue'
import Card from '../../components/CardForContent/CardForContent.vue'
export default Vue.extend({
    name: "ClickSignUpTable",
    components: {
        Card
    },
    data() {
        return {
            clicks: [
                {
                    date: '2021-02-18',
                    clicks: 1,
                    signups: 0,
                    ctr: 0.0,
                    id: 0
                },
                {
                    date: '2021-02-18',
                    clicks: 2,
                    signups: 2,
                    ctr: 50.0,
                    id: 1
                },
                {
                    date: '2021-02-19',
                    clicks: 7,
                    signups: 1,
                    ctr: 33.3,
                    id: 2
                },
            ]
        }
    },
})